/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EnqueteFormQuestionUserVariableDefinitionFragmentDoc } from '../../features/enquete/components/EnqueteForm/EnqueteFormQuestion.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateEnqueteInput = {
  enquete: EnqueteInput;
};

export type EnqueteAnsweredChatMessageInput = {
  body: string;
  selections?: Array<string> | null | undefined;
};

export type EnqueteInput = {
  answeredChatMessage?: EnqueteAnsweredChatMessageInput | null | undefined;
  questions: Array<EnqueteQuestionInput>;
  title: string;
};

export type EnqueteQuestionInput = {
  /** 新規で作成された EnqueteQuestionInput は null である */
  guid?: string | number | null | undefined;
  isAnswerRequired: boolean;
  questionText: string;
  userVariableDefinitionGUID: string | number;
};

export type CreateEnqueteMutationVariables = Exact<{
  input: Types.CreateEnqueteInput;
}>;


export type CreateEnqueteMutation = { createEnquete: { guid: string } };

export type EnqueteNewPageContentUserVariableDefinitionFragment = { guid: string, name: string, value:
    | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueString', void: any }
    | { __typename: 'UserVariableDefinitionValueText', void: any }
   };

export const EnqueteNewPageContentUserVariableDefinitionFragmentDoc = gql`
    fragment EnqueteNewPageContentUserVariableDefinition on UserVariableDefinition {
  ...EnqueteFormQuestionUserVariableDefinition
}
    ${EnqueteFormQuestionUserVariableDefinitionFragmentDoc}`;
export const CreateEnqueteDocument = gql`
    mutation CreateEnquete($input: CreateEnqueteInput!) {
  createEnquete(input: $input) {
    guid
  }
}
    `;

/**
 * __useCreateEnqueteMutation__
 *
 * To run a mutation, you first call `useCreateEnqueteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnqueteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEnqueteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnqueteMutation(options: VueApolloComposable.UseMutationOptions<CreateEnqueteMutation, CreateEnqueteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEnqueteMutation, CreateEnqueteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEnqueteMutation, CreateEnqueteMutationVariables>(CreateEnqueteDocument, options);
}
export type CreateEnqueteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEnqueteMutation, CreateEnqueteMutationVariables>;